export const ENV_ICON = 'DataSource'
export const ENV_PROD_ICON = 'DataSource'
export const ENV_PROD_COLOR = 'var(--color-main)'
export const ENV_PROD_COLOR_LIGHT = 'var(--color-theme-3)'

export const ENV_DEV_COLOR = 'var(--color-gray-500)'
export const ENV_DEV_COLOR_LIGHT = 'var(--color-gray-100)'
